import { AnchorButton, Button, Intent, PopoverInteractionKind, Tooltip } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { Link } from 'react-router'
import { channelById } from '../../../constants/Channels'
import { usePermissions } from '../../../hooks/usePermissions'

const ActionBar = ({ product, listing, channelId, onRelist, onDelist, onRecycle, onDelete, onList }) => {
  const { permissions } = usePermissions()

  const productPurged = !!product.purgedAt
  const productRecycled = !!product.recycledAt && !productPurged
  const channel = channelById(channelId)
  const listable = ['PENDING', 'LISTING_FAILED'].includes(listing.state)
  const delistable = ['LISTED', 'DELISTING_FAILED', 'MODIFY_FAILED'].includes(listing.state)
  const relistable =
    ['DELISTED', 'EXPIRED', 'PURGED', 'PENDING_RELISTING', 'RELISTING_FAILED', 'SOLD'].includes(listing.state) &&
    !productPurged

  let relistTooltipContent = null
  if (!relistable) {
    if (productPurged) {
      relistTooltipContent = "This listing's product has been purged. It cannot be relisted"
    } else {
      relistTooltipContent = 'Can only relist expired, sold, or delisted listings.'
      if (channel.name === 'shopgoodwill') {
        relistTooltipContent += ' Try recycling first.'
      }
    }
  }

  let recycleable = ['DELISTED', 'EXPIRED', 'PURGING_FAILED'].includes(listing.state)

  if (channel.name === 'shopgoodwill') {
    recycleable = ['DELISTED', 'EXPIRED', 'PURGING_FAILED', 'SOLD', 'UNPAID'].includes(listing.state)
  }

  const deleteable = [
    'PENDING',
    'LISTING_FAILED',
    'RELISTING_FAILED'
    // 'DELISTED',
    // 'EXPIRED',
    // 'PURGED'
  ].includes(listing.state)

  return (
    <div className="action-bar bp3-card bp3-elevation-2">
      {listing.uploading && (
        <Tooltip
          interactionKind={PopoverInteractionKind.HOVER_TARGET_ONLY}
          content="Syncing with Facebook. Please wait upload is complete to edit this listing."
        >
          <Button minimal intent={Intent.PRIMARY} icon={IconNames.EDIT} disabled>
            <span className="action-text">Edit Details</span>
          </Button>
        </Tooltip>
      )}
      {!listing.uploading && permissions.includes('products.post') && (
        <Link to={`/listings/${channel.name}/${listing.id}/edit`}>
          <Button minimal intent={Intent.PRIMARY} icon={IconNames.EDIT} disabled={listing.uploading}>
            <span className="action-text">Edit Details</span>
          </Button>
        </Link>
      )}

      {permissions.includes('listings.manage') && listable && (
        <AnchorButton onClick={() => onList(listing.id)} minimal icon={IconNames.UPLOAD} intent={Intent.PRIMARY}>
          <span className="action-text">List</span>
        </AnchorButton>
      )}

      {permissions.includes('listings.manage') && (
        <Tooltip content={!delistable && 'Can only delist listed listings'}>
          <AnchorButton
            disabled={!delistable}
            onClick={() => onDelist(listing.id)}
            minimal
            icon={IconNames.TAKE_ACTION}
            intent={Intent.PRIMARY}
          >
            <span className="action-text">End Early</span>
          </AnchorButton>
        </Tooltip>
      )}

      {permissions.includes('listings.manage') && (
        <Tooltip content={relistTooltipContent}>
          <AnchorButton
            disabled={!relistable}
            onClick={() => onRelist(listing.id, productRecycled ? product.id : null)}
            minimal
            icon={IconNames.REFRESH}
            intent={Intent.SUCCESS}
          >
            <span className="action-text">Relist</span>
          </AnchorButton>
        </Tooltip>
      )}

      {permissions.includes('listings.manage') && (
        <Tooltip content={!recycleable && 'Can only recycle delisted or expired listings'}>
          <AnchorButton
            disabled={!recycleable}
            minimal
            icon={IconNames.REPEAT}
            intent={Intent.WARNING}
            onClick={() => onRecycle(listing.id)}
          >
            <span className="action-text">Recycle</span>
          </AnchorButton>
        </Tooltip>
      )}

      {/* one day? */}
      {/* {unrecycleable && (
        <AnchorButton
          disabled={!unrecycleable}
          minimal
          icon={IconNames.REPEAT}
          intent={Intent.NONE}
          onClick={() => onRecycle(listing.id)}
        >
          <span className="action-text">Unrecycle</span>
        </AnchorButton>
      )} */}

      {permissions.includes('listings.manage') && (
        <Tooltip content={!deleteable && 'Can only delete failed or pending listings'}>
          <AnchorButton
            disabled={!deleteable}
            minimal
            icon={IconNames.TRASH}
            intent={Intent.DANGER}
            onClick={() => onDelete(listing.id)}
          >
            <span className="action-text">Delete</span>
          </AnchorButton>
        </Tooltip>
      )}
    </div>
  )
}
export default ActionBar
